import type { SchemaOrgFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { getSkuPart } from '@packages/modules/src/helpers';
import { getSchemaAvailability } from '../../Tracking/helper/getSchemaAvailability';
import type { SchemaOrgOfferItem } from './types';

export type GetOffersJSONProps = Pick<SchemaOrgFragmentFragment, 'offers'> & {
  currentProduct: Pick<SchemaOrgFragmentFragment, 'price' | 'availability' | 'akl' | 'sku'>;
  url: string;
  companyName: string;
};

export const getOffersJSON = ({
  currentProduct,
  offers,
  url,
  companyName,
}: GetOffersJSONProps): Array<SchemaOrgOfferItem> =>
  [
    {
      currency: currentProduct.price.currency,
      price: currentProduct.price.value,
      availability: getSchemaAvailability(currentProduct.availability),
      sku: getSkuPart(currentProduct.sku, 'OrderNumberPromotionAndSize'),
    },
    ...offers,
  ].map(({ currency, price, availability, sku }) => ({
    '@type': 'Offer',
    priceCurrency: currency || '',
    price: price ? (price / 100).toFixed(2) : '0',
    availability: `http://schema.org/${availability || 'InStock'}`,
    itemCondition: 'http://schema.org/NewCondition',
    itemOffered: {
      '@type': 'IndividualProduct',
      sku: sku || '',
    },
    url,
    seller: {
      '@type': 'Organization',
      name: companyName,
    },
  }));
